import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import { getDataAtual, getDataFormatada, getData, getDataHoraBanco, getDataHoraFormatada } from '../utils/dataUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'ESTOQUE_AJUSTE_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = { datahora_ajuste: getDataAtual() }) {
    return [
        initialize('estoqueAjusteForm', {
			...registro,
			datahora_ajuste: getDataHoraFormatada(registro.datahora_ajuste, 'DD/MM/YYYY HH:mm')
		})
    ];
}

export function getLista(id_empresa) {
    const request = axios.get(`${consts.API_URL}/estoqueajuste?id_empresa=${id_empresa}`);
    return {
        type: 'ESTOQUE_AJUSTE_LISTADO',
        payload: request
    };
}

export function getListaGranja(id_empresa) {
    const request = axios.get(`${consts.API_URL}/granja/listarselect?id_empresa=${id_empresa}`);
    return {
        type: 'ESTOQUE_AJUSTE_GRANJA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaProduto(id_empresa) {
    const request = axios.get(`${consts.API_URL}/produto/listarselect?id_empresa=${id_empresa}`);
    return {
        type: 'ESTOQUE_AJUSTE_PRODUTO_SELECT_LISTADO',
        payload: request
    };
}

export function salvar(registro) {

    return (dispatch, getState) => {
        axios.post(`${consts.API_URL}/estoqueajuste`, {
			...registro,
			id_empresa: getState().auth.usuario.id_empresa,
			datahora_ajuste: getDataHoraBanco(registro.datahora_ajuste)
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(getState().auth.usuario.id_empresa));
            dispatch(setModoTela('lista'));
        }).catch(e => {
            setErroAPI(e);
        });
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/estoqueajuste?id=${registro.id}`)
            .then(resp => {
                setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(getState().auth.usuario.id_empresa));
                dispatch(setModoTela('lista'));
            })
            .catch(e => {
                setErroAPI(e);
            });
    };
}
